export function load_fonts() {
  if (
    document.body.dataset.lang === "zh-TW" ||
    document.body.dataset.lang === "zh-CN"
  ) {
    $("head").append(
      // `<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,500,700&subset=chinese-traditional">`
      `<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Noto+Sans+SC:400,500,700&display=swap&subset=chinese-simplified">`
    );
    // 加载source-han-serif-sc字体
    //  这里的 msp7lrc 是谨严的账号的kitId
    let kitId = "msp7lrc";
    $.getScript(`https://use.typekit.net/${kitId}.js`, () => {
      try {
        Typekit.load({
          kitId,
          // scriptTimeout: 800,
          async: true,
          family: "source-han-serif-sc",
        });
      } catch (e) {}
    });
  }
  //    加载通用的数字字体
  $("head").append(
    '<link href="https://fonts.googleapis.com/css?family=Oxygen:400,700&display=swap" rel="stylesheet">'
  );
}
